/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './languages';
import './countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "client": {
            "nested": {
              "Version": {
                "fields": {
                  "major": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "minor": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "revision": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "prereleaseType": {
                    "type": ".squareup.common.client.Version.PrereleaseType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "prerelease": {
                    "type": "uint32",
                    "id": 5,
                    "rule": "optional"
                  },
                  "buildId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PrereleaseType": {
                    "values": {
                      "ALPHA": 10,
                      "BETA": 20,
                      "PRERELEASE": 30,
                      "RELEASE_CANDIDATE": 40
                    }
                  }
                }
              },
              "Product": {
                "fields": {
                  "application": {
                    "type": ".squareup.common.client.Product.Application",
                    "id": 1,
                    "rule": "optional"
                  },
                  "version": {
                    "type": ".squareup.common.client.Version",
                    "id": 2,
                    "rule": "optional"
                  },
                  "buildType": {
                    "type": ".squareup.common.client.Product.BuildType",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "RELEASE"
                    }
                  },
                  "deviceAdvertisingId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "deviceTrackingEnabled": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deviceInstallationId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Application": {
                    "values": {
                      "REGISTER": 1,
                      "LEGACY_REGISTER": 2,
                      "WALLET": 3,
                      "TAXIDRIVER": 4,
                      "DASHBOARD": 5,
                      "CASH": 6,
                      "APPOINTMENTS": 7
                    }
                  },
                  "BuildType": {
                    "values": {
                      "DEVELOPMENT": 0,
                      "ALPHA": 10,
                      "DOGFOOD": 15,
                      "BETA": 20,
                      "RELEASE": 30
                    }
                  }
                }
              },
              "Device": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": ".squareup.common.client.Device.Platform",
                    "id": 2,
                    "rule": "optional"
                  },
                  "manufacturer": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "brand": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "model": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "osVersion": {
                    "type": ".squareup.common.client.Version",
                    "id": 6,
                    "rule": "optional"
                  },
                  "orientation": {
                    "type": ".squareup.common.client.Device.Orientation",
                    "id": 7,
                    "rule": "optional"
                  },
                  "languageCode": {
                    "type": ".squareup.common.languages.Language",
                    "id": 8,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": ".squareup.common.countries.Country",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Platform": {
                    "values": {
                      "IOS": 0,
                      "ANDROID": 1,
                      "JAVASCRIPT": 2
                    }
                  },
                  "Orientation": {
                    "values": {
                      "PORTRAIT": 0,
                      "PORTRAIT_UPSIDE_DOWN": 1,
                      "LANDSCAPE_LEFT": 2,
                      "LANDSCAPE_RIGHT": 3,
                      "FACE_UP": 4,
                      "FACE_DOWN": 5,
                      "SQUARE": 6
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Version && !$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Version?.nested?.PrereleaseType && !$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Product && !$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Product?.nested?.Application && !$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Product?.nested?.BuildType && !$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Device && !$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Device?.nested?.Platform && !$root.nested?.squareup?.nested?.common?.nested?.client?.nested?.Device?.nested?.Orientation) {
  $root.addJSON(jsonData);
}

/**
 * Common client properties. "Client" in this context means "not
 * server" and includes phones, tablets, and JavaScript apps running
 * in a browser.
 * A generic versioning scheme, e.g., 4.2.1b6/62783438, that can be
 * used both for Square apps and platforms, e.g., Android, iOS,
 * Chrome.  Since we don't control platform versioning we can't force
 * platform to conform to this scheme, in which case fields are best
 * fit. (Still preferable to proto consumers doing ad hoc string
 * parsing.)
 *
 * Everything is optional, both from the proto perspective and
 * semantically: it's possible and valid to only include the major
 * field or to have a build_id SHA and nothing else. It'll depend on
 * what's being described.
 *
 * SOURCE Version @ squareup/common/client.proto at 34:1
 */
export const Version = $root.lookupType('squareup.common.client.Version');
fixType(Version);
Builder.createAndAttachToType(Version);
/**
 * The category of a prerelease. Usually identified by a prerelease
 * demarcation: e.g., the b in 4.2.1b6 means BETA. Modeled after
 * rubygems. Values should have a meaningful sort order.
 *
 * SOURCE PrereleaseType @ squareup/common/client.proto at 40:3
 */
Version.PrereleaseType = $root.lookupEnum('squareup.common.client.Version.PrereleaseType').values;
/**
 * Describes a square product, both released and unreleased.
 *
 * SOURCE Product @ squareup/common/client.proto at 58:1
 */
export const Product = $root.lookupType('squareup.common.client.Product');
fixType(Product);
Builder.createAndAttachToType(Product);
/**
 * SOURCE Application @ squareup/common/client.proto at 59:3
 */
Product.Application = $root.lookupEnum('squareup.common.client.Product.Application').values;
/**
 * The build type (in contrast to prerelease type above. For example, DEVELOPMENT in
 * com.squareup.square.development.)
 *
 * SOURCE BuildType @ squareup/common/client.proto at 85:3
 */
Product.BuildType = $root.lookupEnum('squareup.common.client.Product.BuildType').values;
/**
 * Describes devices that run Square products and specifically
 * includes JavaScript apps that run in browsers on non-mobile
 * "devices", e.g., Dashboard running on a laptop.  It includes static
 * attributes, e.g., vendor, and dynamic attributes, e.g., device
 * orientation.
 *
 * The scope of this description is whatever is useful to consumers,
 * e.g., analytics. In particular, we aren't recording much about
 * devices running JavaScript apps like Dashboard. The intention is
 * that it be extended as required by consumers.
 *
 * SOURCE Device @ squareup/common/client.proto at 118:1
 */
export const Device = $root.lookupType('squareup.common.client.Device');
fixType(Device);
Builder.createAndAttachToType(Device);
/**
 * SOURCE Platform @ squareup/common/client.proto at 119:3
 */
Device.Platform = $root.lookupEnum('squareup.common.client.Device.Platform').values;
/**
 * SOURCE Orientation @ squareup/common/client.proto at 125:3
 */
Device.Orientation = $root.lookupEnum('squareup.common.client.Device.Orientation').values;